import React, { Fragment, useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getAddressBook, deleteAddressbook } from "../../actions/addressbook";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import SweetAlert from "react-bootstrap-sweetalert";
const Index = (props) => {
  const [value, setValue] = useState({
    addressess: [],
  });

  useEffect(async () => {
    const res = await props.getAddressBook();
    setValue({ ...value, addressess: value });
  }, []);

  const _deleteAddressbook = async (id) => {
    props.deleteAddressbook(id);
    const res = await props.getAddressBook();

    setValue({ ...value, addressess: res, deleteConfirm: false });
  };
  const _onCancel = () => {
    setValue({ ...value, deleteConfirm: false });
  };

  return (
    <Fragment>
      <div className="addressBook-wrapper wrapper-90 max-1600">
        <ul className="breadcrumb">
          <li>
            <a href="index.html">
              <i className="fa fa-home" />
            </a>
          </li>
          <li>
            <Link to="/dashboard"> / Account</Link>
          </li>
          <li>
            <a href=""> / Address Book</a>
          </li>
        </ul>
        <div className="container-fluid">
          <div className="row">
            <AccountLeftSidebar />
            <div className="col-md-9">
              <div className="addressBook-entries">
                <header className="addressBook-entries-title">
                  <h3>Address Book Entries</h3>
                </header>
                {props.location.successMessage && (
                  <div
                    key={alert.id}
                    variant={alert.alertType}
                    className={`alert alert-success`}
                    role="alert"
                    style={{ marginTop: "3em", marginBottom: "2em" }}
                  >
                    {props.location.successMessage}
                  </div>
                )}

                {value.addressess &&
                  value.addressess.length > 0 &&
                  value.addressess.map((item, index) => (
                    <div key={index} className="addressBook-address">
                      <div className="person-add-book">
                        <p className="m-0 "> {item.firstName}</p>
                        <p className="m-0 ">{item.lastName}</p>
                        <p className="m-0 ">{item.company}</p>
                        <p className="m-0 ">{item.city}</p>
                        <p className="m-0 ">{item.postCode}</p>
                        <p className="m-0 ">{item.region}</p>
                        <p className="m-0 ">{item.address}</p>
                        <p className="m-0 ">{item.country} </p>
                      </div>
                      <div className="edit-dlt-addBook">
                        <button className="edit-add-book">
                          <Link to={`/edit-address-book/${item._id}`}>
                            <span style={{ color: "#fff" }}>Edit</span>
                          </Link>
                        </button>

                        <button
                          onClick={() => {
                            setValue({ deleteConfirm: true });
                          }}
                          className="dlt-add-book"
                        >
                          <span>Delete</span>
                        </button>
                        {value.deleteConfirm && (
                          <SweetAlert
                            warning
                            showCancel
                            confirmBtnText="Yes, delete it!"
                            confirmBtnBsStyle="danger"
                            title="Are you sure?"
                            onConfirm={() => {
                              _deleteAddressbook(item._id);
                            }}
                            onCancel={_onCancel}
                            focusCancelBtn
                          >
                            Are you sure you want to delete?
                          </SweetAlert>
                        )}
                      </div>
                    </div>
                  ))}
                <div className="add-book-footer">
                  <Link to="/dashboard">
                    <button className="back-addBook">
                      <span style={{ color: "#fff" }}>Back</span>
                    </button>
                  </Link>
                  {/*   {" "} */}

                  <Link to="/add-new-address-book">
                    <button className="newAdd-addBook">New Address</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

getAddressBook.propTypes = {
  getAddressBook: PropTypes.func.isRequired,
};
deleteAddressbook.propTypes = {
  deleteAddressbook: PropTypes.func.isRequired,
};
export default withRouter(
  connect(null, { getAddressBook, deleteAddressbook })(Index)
);
